export const isTeamSport = (sport: string | undefined) => {
  const invidividualSports = ['PGA', 'NASCAR', 'MMA'];
  return !invidividualSports.includes(sport?.toUpperCase() || '');
}